<template>
  <div class="w-10/12 mx-auto flex-row flex-wrap justify-between font-costea">

    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-h24 font-medium text-costeaBlack">
        Gestión de categorías
      </h1>
      <div class="flex flex-row items-center">
        <!--<div class="flex flex-row bg-white items-center justify-center px-4 w-48 h-10 box-border text-costeaGray text-t14 rounded-md">
          <i class="ri-search-line mx-2"></i>
          <input type="text" name="search_cat" id="search_cat" class="w-40 outline-none pr-2" placeholder="Busca una categoría">
        </div>-->
        <p class="text-costeaGray ml-6 mr-3 text-t14">
          <span class="text-costeaBlack font-medium">{{page}}</span> de <span>{{getPageNumber()}}</span>
        </p>
        <div class="flex flex-row h-full">
          <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50" @click="page--, getPageNumber()" v-if="page != 1"><i class="ri-arrow-left-line"></i></button>
          <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()" v-show="page < getPageNumber()"><i class="ri-arrow-right-line"></i></button>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-x-5">
          <div class="col-start-1 col-end-13 bg-white p-6 rounded-md">
            <div>
              <div class="h-10 flex flex-row items-center font-costea text-t14 border-b-2">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Nombre de la categoría</span>
              </div>

              <div>
                <div v-for="cat in displayedCategories" :key="cat.index"
                 class="h-14 flex flex-row items-center font-costea text-t14 border-b-2 border-gray-100 hover:bg-costeaContainer">
                  <span @click="showModalEdit(cat.name, cat.id)" class="hover:underline px-2 cursor-pointer text-costeaGray">{{cat.name}}</span>
                  <div class="flex ml-auto">
                    <button @click="showModalDelete(cat.name, cat.id)" class="ml-2 mr-2 bg-gray-100 text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaDarkSalmon h-6 w-6 rounded-full flex justify-center items-center"><i class="ri-delete-bin-6-line"></i></button>
                    <button @click="showModalEdit(cat.name, cat.id)" class="ml-2 mr-2 bg-gray-100 text-costeaGray hover:bg-costeaPrimaryDisabled hover:text-costeaPrimary h-6 w-6 rounded-full flex justify-center items-center"><i class="ri-edit-line"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div> 

    <transition name="page">
      <component @closeModalAdd="handleAddCatCloseModal" @reloadData="reloadData"  v-show="this.modalActive" :is="selected"/>
    </transition>

    <transition name="page">
      <component :catOld="editName" :idCat="parseInt(editId)" @closeModalEdit="handleEditCatCloseModal" @reloadData="reloadData"  v-show="this.modalEditActive" :is="editModal"/>
    </transition>

    <transition name="page">
      <component :catName="deleteName" :idCat="parseInt(deleteId)" @closeModalDelete="handleDeleteCatCloseModal" @reloadData="reloadData"  v-show="this.modalDeleteActive" :is="deleteModal"/>
    </transition>

    <buttonAdd @showModal="handleShowCategories"/>
    
  </div>

</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import buttonAdd from '@/components/elements/ButtonAdd.vue'
import editCategory from '@/components/categories/EditCategories.vue'
import deleteCategory from '@/components/categories/DeleteCategories.vue'
import modal from '@/components/categories/AddCategories.vue' 

export default {
    name : "Categories",
    components:{
      buttonAdd,
      modal,
      editCategory,
      deleteCategory
    },
    data(){
      return{
        categories: [],
        page: 1,
        pages:[],
        elementsPerPage: 10,
        modalActive : false,
        selected: 'modal',
        editName: '',
        editId:0,
        deleteName: '',
        deleteId:0,
        modalEditActive: false,
        modalDeleteActive: false,
      }
    },
    computed:{
      ...mapState(['costea']),
      
      displayedCategories(){
        return this.paginate(this.categories);
      },
      editModal(){
        if(this.modalEditActive){
          return 'editCategory'
        }else{
          return ''
        }
      },
      deleteModal(){
        if(this.modalDeleteActive){
          return 'deleteCategory'
        }else{
          return ''
        }
      }
    },
    methods:{
      getCategories: function(){

          axios
          .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}categories`)
            .then( respuesta => {
                if(respuesta.data.status == false){
                  this.$router.push('/login')
                }
                this.categories = respuesta.data; 
                this.pages = []
                this.setPages()
                console.log(respuesta.data)
            }).catch((error) => {
            if(error.response.status === 401){
                this.$router.push('/login')
            }
        })
      },
      reloadData(value){
        if(value === true){
          this.getCategories()
          value = false
        }else{
          console.log('Ocurrio un error')
        }
      },
      handleShowCategories(value){
        this.modalActive = value
      },
      handleAddCatCloseModal(value){
        this.modalActive = value
      },
      handleEditCatCloseModal(value){
        this.modalEditActive = value
      },
      handleDeleteCatCloseModal(value){
        this.modalDeleteActive = value
      },
      showModalEdit(catName, catId){
        if(this.modalEditActive === false){
            this.modalEditActive = true
            this.editName = catName
            this.editId = parseInt(catId)
        }else{
          this.modalEditActive = false
        }
      },
      showModalDelete(catName, catId){
        if(this.modalDeleteActive === false){
            this.modalDeleteActive = true
            this.deleteName = catName
            this.deleteId = parseInt(catId)
        }else{
          this.modalDeleteActive = false
        }
      },

      setPages(){
        let numberOfPages = Math.ceil(this.categories.length / this.elementsPerPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
      },
      paginate(category) {
          let page = this.page;
          let perPage = this.elementsPerPage;
          let from = (page * perPage) - perPage;
          let to = (page * perPage);
          return  category.slice(from, to);
      },
      getPageNumber(){
          return this.pages.length
      }
    },
    
    beforeMount(){
      if(localStorage.getItem('token')){
        this.getCategories()
      }else{
        this.$router.push('/login')
      }
      
    },

}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
</style>